// extracted by mini-css-extract-plugin
export var actionButton = "_xs-2";
export var card = "_xs-0";
export var disambiguationList = "_xs-3";
export var errorCard = "_xs-4";
export var row = "_xs-1";